import { render, staticRenderFns } from "./ButtonContent.vue?vue&type=template&id=46031628&scoped=true&"
import script from "./ButtonContent.vue?vue&type=script&lang=js&"
export * from "./ButtonContent.vue?vue&type=script&lang=js&"
import style0 from "./ButtonContent.vue?vue&type=style&index=0&id=46031628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46031628",
  null
  
)

export default component.exports